var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.293 12.46c.427.17.707.584.707 1.044v12.992c0 .46-.28.874-.707 1.045l-10.875 4.35a1.125 1.125 0 0 1-.836 0L8.707 27.54A1.125 1.125 0 0 1 8 26.496V13.504c0-.46.28-.874.707-1.045l10.457-4.183a2.64 2.64 0 0 1 .014-.005l.404-.162c.268-.107.568-.107.836 0l.404.162.014.005 10.457 4.183zM23.605 11l-9.23 3.692-3.605-1.442-1.27.508v.6l9.75 3.9v11.884l.75.3.75-.3V18.258l9.75-3.9v-.6l-1.27-.508L20 16.942 16.394 15.5l9.23-3.692L23.607 11z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M31.293 12.46c.427.17.707.584.707 1.044v12.992c0 .46-.28.874-.707 1.045l-10.875 4.35a1.125 1.125 0 0 1-.836 0L8.707 27.54A1.125 1.125 0 0 1 8 26.496V13.504c0-.46.28-.874.707-1.045l10.457-4.183a2.64 2.64 0 0 1 .014-.005l.404-.162c.268-.107.568-.107.836 0l.404.162.014.005 10.457 4.183zM23.605 11l-9.23 3.692-3.605-1.442-1.27.508v.6l9.75 3.9v11.884l.75.3.75-.3V18.258l9.75-3.9v-.6l-1.27-.508L20 16.942 16.394 15.5l9.23-3.692L23.607 11z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.bd8b0f442a30cec473f93740f0b232c7.svg";
export { ForwardRef as ReactComponent };